import { render, staticRenderFns } from "./HotelSegment.vue?vue&type=template&id=4a0d5bd6&"
import script from "./HotelSegment.vue?vue&type=script&lang=js&"
export * from "./HotelSegment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports